import styled from 'styled-components'

export const FacebookSVG = styled.svg`
  .cls-1 {
    fill: #1877f2;
  }
`
